<script setup lang="ts">
import router from "@/router";
import _service from "@/service";
import { closeToast, showLoadingToast, showToast } from "vant";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const urlParams = new URLSearchParams(window.location.search);
const futurePay = async () => {
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    const _param:string = urlParams.get("param") || ''
    const orderData = JSON.parse(_param);
    console.log(orderData,'orderData');
    
    const res: any = await _service.submitOrder(orderData);
    if (!res.data) {
      window.location.replace(`${window.location.origin}/pay-fail`);
      return false;
    }
    if (res.data.displayMode === "url") {
      window.top.location.href = res.data.displayContent;
      // window.location.href = res.data.displayContent
    }
    closeToast();
  } catch (error) {
    console.error(error);
  }
};

onMounted(() => {
  const token = !import.meta.env.DEV ? (window as any).APLINK_STARNEST?.token : sessionStorage.getItem('APLINK_STARNEST_TOKEN');
  const orderData = urlParams.get("param");
  if (token) {
    orderData && futurePay();
  } else {
    showToast("No Token");
  }
});
</script>

<template>
  <div class="layout"></div>
</template>

<style lang="scss" scoped>
.layout {
  height: 100%;
  min-height: 100vh;
  background: #070b14;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
}
</style>
